import { Flex, Text } from '@cad-arc';
import { UnitQueueView } from '@mark43/cad-api';
import { useTimeSince } from './use-time-since';
import { unitStatusColors } from '../common/helpers/styles';
import { Tooltip } from '../common/components/tooltip';

const NOT_AVAILABLE = 'N/A';

export function FrUnitStatus({ unit, vertical }: { unit: UnitQueueView; vertical?: boolean }) {
    const { statusCode, timeInStatusDateTime, unitStateGroup } = unit;
    const timeSince = useTimeSince(new Date(timeInStatusDateTime ?? new Date().toUTCString()));
    const timeSinceText = timeInStatusDateTime ? timeSince : NOT_AVAILABLE;
    const unitStatusColor = unitStatusColors[unitStateGroup];

    return (
        <Flex userSelect="none" w="100%" justifyContent="center" alignItems="center">
            <Flex
                data-testid={`fr-unit-status-badge-${unit.id}`}
                h="100%"
                w="100%"
                borderRadius={vertical ? 'md' : 'var(--arc-radii-base)'}
                bgColor={unitStateGroup ? unitStatusColor.fill : 'surface.canvas'}
                alignItems="center"
                justifyContent="center"
                p={vertical ? 1 : 0}
                px={vertical ? 0 : 3}
                gap={vertical ? 2 : 4}
                flexDirection={vertical ? 'column' : 'row'}
            >
                <Text fontSize="lg" fontWeight="bold" lineHeight={1.5} style={{ color: unitStatusColor.text }}>
                    {statusCode}
                </Text>
                {vertical ? (
                    <Text noOfLines={1} fontSize="md" lineHeight={1.5} style={{ color: unitStatusColor.text }}>
                        {timeSinceText}
                    </Text>
                ) : (
                    <Tooltip overlay={timeSinceText}>
                        <Text noOfLines={1} fontSize="md" lineHeight={1.5}>
                            {timeSinceText}
                        </Text>
                    </Tooltip>
                )}
            </Flex>
        </Flex>
    );
}
